import io from 'socket.io-client';
import AppContext from "./app-context"
import { BACKEND_URL, BACKEND_PATH } from "./const"

const socket = io(`${BACKEND_URL}`, {
    path: `${BACKEND_PATH}`,
});

const requestData = (user, object, args, fn = 'list', responsePrefix = "") =>{
    const normalizedArgs = args || {};
    const requestedPage = normalizedArgs.page || AppContext.pages[object]?.pageNum || 1;
    const { page, ...restArgs } = normalizedArgs;
    AppContext.pages[object] = {...(AppContext.pages[object] || {}), pageNum: requestedPage}

    const search = JSON.parse(localStorage.getItem(`${object}_search`))

    //const simple_search_text = localStorage.getItem(`${object}_simple_search_text`) || ""; simple_search_text: simple_search_text

    let searchData = {}
    search && Object.keys(search).forEach((field) => {
        let propName = `simple_search_${field}`
        searchData = {...searchData, [propName]: search[field]}
        //localStorage.setItem(`${props.object}_${field}`, props.fieldsData[data])
    })

    const data = {token: user.token,user_id: user.user_id, page: requestedPage, items_count: 10, ...searchData, response_prefix: responsePrefix, ...restArgs}

    socket.emit(`${object}:${fn}`, data);
}

const listener = (object, setState) => {
    let fn = "list"
    if(object.fn && object.fn != "") fn = object.fn

    socket.on(`${object.name}:${fn}-data`, (data) => {
        setState(data)
    });

    return () => {
        socket.off(`${object.name}:${fn}-data`);
    };
}

const socketUseEffect = (objectsList, user) => {
    objectsList.forEach((object) => {
        let responsePrefix = object.responsePrefix || ""
        if (responsePrefix != "") responsePrefix = `-${responsePrefix}`
        socket.on(`${object.name}:${object.fn}-data${responsePrefix}`, (data) => {
           if(object.row){
               object.saveDataFN(data.data && data.data[object.row] || [])
           }else{
               object.saveDataFN(data)
           }
        });

        //const { user } = useAuth();
        requestData(user, object.name, object.args, object.fn, object.responsePrefix || "");

        if( object.interval &&  object.interval > 999 ){
            setInterval(() => {
                requestData(user, object.name, object.args || {}, object.fn, object.responsePrefix || "");
            }, object.interval);
        }
    });

    return () => {
        objectsList.forEach((object) => {
            let responsePrefix = object.responsePrefix || ""
            if (responsePrefix != "") responsePrefix = `-${responsePrefix}`

            socket.off(`${object.name}:${object.fn}-data${responsePrefix}`);
        });
    };
}

export {socket, requestData, listener, socketUseEffect}
